<template>
    <div class="find-a-doctor-info">
        <div class="container">
            <div class="find-a-doctor-info__text" v-text="text" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        query: {
            type: String,
            default: '',
        },
        count: {
            type: Number,
        },
        type: {
            type: String,
            default: '',
        },
    },
    computed: {
        text() {
            let str = `${this.count} ${this.type.toLowerCase()} matched your search`;

            if (this.query) {
                str += ` "${this.query}"`
            }

            return str;
        }
    }
};
</script>
